import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import DefaultCommercial from "../pages/commercial/default";
import Live from "../pages/commercial/Live";
import Yesterday from "../pages/commercial/Yesterday";
import Week from "../pages/commercial/Week";
import Month from "../pages/commercial/Month";
import LastWeek from "../pages/commercial/LastWeek/LastWeek";
import LastMonth from "../pages/commercial/LastMonth/LastMonth";
import RootLayout from "../components/RootLayout";
import DefaultOperational from "../pages/operational/default";
import Price from "../pages/operational/Price";
import Detention from "../pages/operational/Detention";
import Shrinkage from "../pages/operational/Shrinkage";
import Client from "../pages/client";
import DefaultEcom from "../pages/ecom/default";
import DefaultDrive from "../pages/ecom/drive";
import DefaultNetwork from "../pages/Network";
import DefaultTable from "../pages/Table";
import DefaultRegionTable from "../pages/Region";
import Alert from "../pages/Alert";
import CALive from "../pages/CALive";

import NotFoundPage from "../components/NotFoundPage";
import AuthenticationGuard from "../components/AuthenticationGuard";
import HandleAuthCallback from "../components/HandleAuthCallback/HandleAuthCallback";
import RegionAlertTable from "../components/RegionAlertTable";
import LandingPage from "../components/Dashboard/LandingPage";
import AdminPage from "../pages/Admin";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      
      <Route path="/callback" element={<HandleAuthCallback />} />

      
      <Route path="/" element={<AuthenticationGuard component={<RootLayout />} />}>
        {/* commercial */}
        <Route index element={<DefaultCommercial />} />
        <Route path="commercial" element={<DefaultCommercial />} />
        <Route path="commercial/live" element={<Live />} />
        <Route path="commercial/yesterday" element={<Yesterday />} />
        <Route path="commercial/week" element={<Week />} />
        <Route path="commercial/lastweek" element={<LastWeek />} />
        <Route path="commercial/month" element={<Month />} />
        <Route path="commercial/lastmonth" element={<LastMonth />} />

        {/* operational */}
        <Route path="operational" element={<DefaultOperational />} />
        <Route path="operational/price" element={<Price />} />
        <Route path="operational/detention" element={<Detention />} />
        <Route path="operational/shrinkage" element={<Shrinkage />} />

        {/* client */}
        <Route path="client" element={<Client />} />

        {/* ecom */}
        <Route path="ecom" element={<DefaultEcom />} />
        <Route path="ecom/drive" element={<DefaultDrive />} />

        {/* network */}
        <Route path="network" element={<DefaultNetwork />} />

        {/* tables */}
        <Route path="table" element={<DefaultTable />} />

        {/* region */}
        <Route path="region/direct" element={<DefaultRegionTable />} />
        <Route path="region/j-1" element={<DefaultRegionTable />} />
        <Route path="region/week" element={<DefaultRegionTable />} />
        <Route path="region/month" element={<DefaultRegionTable />} />

        {/* region */}
        <Route path="region/alertes" element={<RegionAlertTable />} />

        {/* alert */}
        <Route path="alert" element={<Alert />} />

        {/* ca-live */}
        <Route path="ca-live" element={<CALive />} />

        {/* dashboard */}
        <Route path="dashboard" element={<LandingPage />} />

        {/* admin kpi batch audit */}
        <Route path="admin" element={<AdminPage />} />

        {/* 404 sous le layout */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      {/* 404 globale (optionnel) */}
      {/* <Route path="*" element={<NotFoundPage />} /> */}
    </>
  )
);

export default function RoutesPath() {
  return <RouterProvider router={router} />;
}
